import * as d3ease from 'd3-ease';
import {select as d3Select} from 'd3-selection';
import { useLayoutEffect } from 'react';
// Custom hooks
import useAnimated from './useAnimated';
// Constants
import * as constants from './constants';

const TripBarVisible = ({ height, new_width, y, new_x, fill, link_icon, link_font_size, initial_anim_delay }) => {

  const [trip_bar_ref, {width, 'x' : trip_bar_x}] = useAnimated({
    attrs : {'width' : new_width, 'x' : new_x},
    duration : constants.SELECTION_ANIM_DURATION,
    deps : [new_width, new_x]
  });
  const [link_icon_ref, {'x': link_icon_x, 'opacity' : link_icon_opacity}] = useAnimated({
    // opacity rests at 1 and is only moved by the fade in below, so it is a
    // no-op here except when that fade in gets interrupted - in which case this
    // finishes it off rather than leaving the icon stuck part faded.
    attrs : {'x' : new_x, 'opacity' : 1},
    duration : constants.SELECTION_ANIM_DURATION,
    deps : [new_x]
  });

  // Initial animation
  useLayoutEffect(() => {
    const delay = constants.TRIPBAR_INITIAL_ANIM_DELAY_MIN + initial_anim_delay * constants.TRIPBAR_INITIAL_ANIM_DELAY_RANGE;
    d3Select(trip_bar_ref.current)
      .attr('width', 0)
      .transition()
      .duration(constants.TRIPBAR_INITIAL_ANIM_DURATION)
      .delay(delay)
      .ease(d3ease.easeBackOut)
      .attr('width', width)
    d3Select(link_icon_ref.current)
      .attr('opacity', 0)
      .transition()
      .duration(constants.TRIPBAR_INITIAL_ANIM_DURATION)
      .delay(delay)
      .attr('opacity', 1)
  }, []);

  return (<>
    <rect ref={trip_bar_ref}
          className='trip_bar_visible'
          height={height}
          width={width}
          y={y}
          x={trip_bar_x}
          fill={fill}/>
    {link_icon ? <text ref={link_icon_ref}
                       style={{fontSize : link_font_size}}
                       className="link_icon"
                       y={y}
                       x={link_icon_x}
                       opacity={link_icon_opacity}
                       dy="1em">
                   🔗
                 </text>
               : null}
  </>);
};

export default TripBarVisible;
